import { createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
    data: null,
    isFetching: false,
    isSuccess: false,
    isError: false,
    error: null,
});

const generateMFACodeSlice = createSlice({
    name: "generateMFACodeSlice",
    initialState: INITIAL_STATE,
    reducers: {
        generateMFACodeRequest: (state) => {
            state.isFetching = true;
        },
        generateMFACodeSuccess: (state, action) => {
            state.isFetching = false;
            state.isSuccess = true;
            state.data = action.payload;
        },
        generateMFACodeFailure: (state, action) => {
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = true;
            state.error = action.payload;
        },
        resetGenerateMFACode: (state) => {
            state.data = null;
            state.error = null;
            state.isError = false;
            state.isFetching = false;
            state.isSuccess = false;
        },
    },
});

// Exporting actions for saga and views
export const {
    generateMFACodeRequest,
    generateMFACodeSuccess,
    generateMFACodeFailure,
    resetGenerateMFACode,
} = generateMFACodeSlice.actions;

export default generateMFACodeSlice.reducer;
